<div class="right-panel h-100 text-grey">
  <div class="d-flex flex-column h-100">
    <div class="actionBar">
      <div class="flex-grow-1 h-100">
        <input
          class="search w-100"
          type="text"
          placeholder="Search registries..."
          [(ngModel)]="searchTerm"
          (input)="filterRegistries()"
        />
      </div>
      <button
        (click)="loadRegistries()"
        type="button"
        class="actionBtn"
        triggers="hover"
        ngbTooltip="Refresh Registries"
      >
        <span class="bi bi-arrow-clockwise"></span>
      </button>
      <button
        (click)="createRegistry()"
        type="button"
        class="actionBtn"
        triggers="hover"
        ngbTooltip="Add New Registry"
      >
        <span class="bi bi-device-hdd"></span>
        <span class="bi bi-plus-circle-fill overlay-icon-plus"></span>
      </button>
    </div>

    <div class="right-side w-100">
      <div class="w-100">
        <div class="jobs">
          <table
            class="table table-hover table-condensed"
            cellspacing="0"
            id="sessionInfoList"
            style="border-collapse: collapse; white-space: nowrap"
          >
            <thead>
              <tr
                class="table-list-head jobHeadRow"
                style="color: white; background-color: var(--s-primary-color)"
              >
                <th resizable scope="col">
                  <a style="text-decoration: none; cursor: default">#</a>
                </th>
                <th resizable scope="col">
                  <a style="text-decoration: none; cursor: default"> Name </a>
                </th>
                <th resizable scope="col">
                  <a style="text-decoration: none; cursor: default"> Ports </a>
                </th>
                <th resizable scope="col">
                  <a style="text-decoration: none; cursor: default"> Status </a>
                </th>
                <th resizable scope="col">
                  <a style="text-decoration: none; cursor: default">
                    Created
                  </a>
                </th>
                <th resizable scope="col">
                  <a style="text-decoration: none; cursor: default">
                    Actions
                  </a>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                class="table-list-row jobRow"
                style="cursor: pointer"
                *ngFor="let registry of filteredRegistries; let i = index"
              >
                <td style="cursor: pointer" scope="row">{{ i + 1 }}</td>
                <td style="cursor: pointer" scope="row">{{ registry.name }}</td>
                <td style="cursor: pointer" scope="row">
                  <span class="badge-info">{{ registry.ports }}</span>
                </td>
                <td style="cursor: pointer" scope="row">
                  <span
                    [ngClass]="{
                      'badge-success': registry.status === 'running',
                      'badge-warning': registry.status === 'stopped',
                      'badge-danger': registry.status === 'error'
                    }"
                  >
                    {{ registry.status | titlecase }}
                  </span>
                </td>
                <td style="cursor: pointer" scope="row">
                  {{ formatDate(registry.created) }}
                </td>
                <td>
                  <button
                    (click)="startRegistry(registry)"
                    type="button"
                    class="listBtn"
                    triggers="hover"
                    ngbTooltip="Start Registry"
                  >
                    <span
                      class="bi bi-play"
                      style="
                        color: var(--s-primary-color);
                        font-size: large;
                        margin-right: 2px;
                      "
                    ></span>
                  </button>
                  <button
                    (click)="stopRegistry(registry)"
                    type="button"
                    class="listBtn"
                    triggers="hover"
                    ngbTooltip="Pause Registry"
                  >
                    <span
                      class="bi bi-pause text-warning"
                      style="
                        color: var(--s-primary-color);
                        font-size: large;
                        margin-right: 2px;
                      "
                    ></span>
                  </button>
                  <button
                    (click)="deleteRegistry(registry)"
                    type="button"
                    class="listBtn"
                    triggers="hover"
                    ngbTooltip="Delete Registry"
                  >
                    <span
                      class="bi bi-trash text-danger"
                      style="
                        color: var(--s-primary-color);
                        font-size: large;
                        margin-right: 2px;
                      "
                    ></span>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
  <ngx-spinner
    bdColor="rgba(0,0,0,0)"
    size="default"
    zIndex="1"
    color="var(--s-primary-color)"
    type="ball-spin"
    [fullScreen]="false"
  >
    <p class="pleaseWait text-grey">Please wait ...</p>
  </ngx-spinner>
</div>
